import client from '../client'

export async function MarkMessagesAsSeen({ conversationId }) {
  return client(`${process.env.NEXT_PUBLIC_CHAT_DOMAIN}/api/Chat/MarkMessagesAsSeen`, {
    headers: { 'content-type': 'application/json' },
    method: 'POST',
    body: JSON.stringify({ conversationId }),
  })
}
